import { render, staticRenderFns } from "./relativa-pronomen-nominativ.vue?vue&type=template&id=642dfeea&scoped=true"
import script from "./relativa-pronomen-nominativ.vue?vue&type=script&lang=js"
export * from "./relativa-pronomen-nominativ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642dfeea",
  null
  
)

export default component.exports